import { useTranslation } from 'react-i18next';
import { Icon, Paper, Stack, styled, Text } from 'shell/components';

const ACTIVE_ROSTER_SYNC_STATUSES = ['queued', 'running'];

const RosterSyncStatus = ({ status, error, progress }) => {
    const { t } = useTranslation();
    const hasProgress = Number.isFinite(progress?.processed_count) && Number.isFinite(progress?.total_count);

    if (!status) return null;
    if (ACTIVE_ROSTER_SYNC_STATUSES.includes(status)) {
        return (
            <ActiveStatusContainer alignItems={'center'} direction={'row'} spacing={3}>
                <Stack spacing={1}>
                    <Stack alignItems={'center'} direction={'row'} spacing={1}>
                        <Text variant={'p1'} weight={'semibold'}>
                            {t('people.roster-sync.in-progress-title', 'Roster Sync In Progress')}
                        </Text>
                        <Icon kind={'clock'} />
                    </Stack>
                    <Text color={'light'}>
                        {hasProgress && progress.total_count > 0
                            ? t(
                                  'people.roster-sync.in-progress-with-progress-description',
                                  'We are syncing your LMS roster in the background. {{processed}}/{{total}} roster changes processed.',
                                  {
                                      processed: progress.processed_count,
                                      total: progress.total_count,
                                  }
                              )
                            : t(
                                  'people.roster-sync.in-progress-description',
                                  'We are syncing your LMS roster in the background. New users will appear here automatically when it finishes.'
                              )}
                    </Text>
                </Stack>
            </ActiveStatusContainer>
        );
    }

    if (status === 'failed') {
        return (
            <StatusPaper variant={'outlined'} status={status}>
                <Stack alignItems={'center'} direction={'row'} spacing={3}>
                    <Icon kind={'error'} />
                    <Stack spacing={1}>
                        <Text variant={'p1'} weight={'semibold'}>
                            {t('people.roster-sync.failed-title', 'Roster Sync Failed')}
                        </Text>
                        <Text color={'light'}>
                            {error ||
                                t(
                                    'people.roster-sync.failed-description',
                                    'We could not finish syncing your LMS roster. Please try again in a moment.'
                                )}
                        </Text>
                    </Stack>
                </Stack>
            </StatusPaper>
        );
    }

    return null;
};

const ActiveStatusContainer = styled(Stack)(({ theme }) => {
    return {
        padding: theme.spacing(5),
        borderRadius: 12,
        background: theme.palette.ensightful.primary[50],
    };
});

const StatusPaper = styled(Paper)(({ theme }) => {
    return {
        padding: theme.spacing(5),
        borderRadius: 12,
        background: theme.palette.ensightful.primary[50],
    };
});

export default RosterSyncStatus;
